import { ErrorBoundary } from "../../components/error-boundary";
import ErrorBoundaryUi from "../../components/error-boundary-ui";

export const ErrorBoundaryHoc = (props) => {
  const { children } = props;
  return (
    <ErrorBoundary fallback={<ErrorBoundaryUi />}>{children}</ErrorBoundary>
  );
};
